import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const labelFormatSchema = z.object({
  width: z.number(),
  height: z.number(),
});
export type LabelFormat = z.infer<typeof labelFormatSchema>;

export const printProductBarcodes = {
  name: "printProductBarcodes" as const,
  input: z.object({
    teamId: zExt.objectId(),
    warehouseId: zExt.objectId(),
    productIds: z.array(
      z.object({ id: zExt.objectId(), variantSku: z.string() }),
    ),
    labelFormat: labelFormatSchema.optional().default({ width: 2, height: 1 }),
    includeSku: z.boolean().optional().default(true),
    includeTitle: z.boolean().optional().default(true),
    includeMerchantName: z.boolean().optional().default(true),
  }),
  output: z.object({ url: z.string() }),
};
